
enum PermitType {
    ALL = -1,
    REGULAR = 0,
    GOLDEN = 1,
    STUDENT =  2,
    HANDICAPPED = 3,
    MUNICIPAL_EMPLOYEE = 4,
    TAXI = 5,
    PERMIT_BY_ZONE =  6,
    NONE_RESIDENT =  7,
    BUSINESS =  8,
}

export default PermitType;